import { View, Text } from '@react-pdf/renderer';
import { useTranslation } from 'react-i18next';
import styles from '../common/styles';
import { ChemicalProductDTO } from '@behavior/inventories/dto/ChemicalProductDTO';
import { ActivityChemicalsDTO } from '@behavior/activity/dto/ActivityChemicalsDTO';
import lodash from 'lodash';

type Props = {
  width: number;
  chemicalProductTable: {
    header: string[];
    data: Array<keyof ChemicalProductDTO>;
  };
  chemicalProducts: ActivityChemicalsDTO[];
};

export const ActivityChemicalProductTable = ({
  width,
  chemicalProductTable,
  chemicalProducts,
}: Props) => {
  const { t } = useTranslation();

  return (
    <View style={[styles.thinRoundBorder]}>
      <View style={styles.accordianSubTitle}>
        <Text>{t('activity.report.page.components.activity.chemical.products')}</Text>
      </View>
      <View style={styles.table}>
        <View style={styles.tableRow}>
          {chemicalProductTable.header.map(colName => {
            return (
              <View style={[{ width: width }, styles.bold]}>
                <Text>{colName}</Text>
              </View>
            );
          })}
        </View>
        {chemicalProducts.map(product => {
          return (
            <View style={styles.tableRow}>
              {chemicalProductTable.data.map(colName => {
                return (
                  <View style={[{ width: width }, styles.bold]}>
                    <Text>{t(lodash.get(product.chemicalProduct, colName) as string)}</Text>
                  </View>
                );
              })}
            </View>
          );
        })}
      </View>
    </View>
  );
};
